// Everyone's tech time on each ticket, for the Service Queue rows and the
// Workbench cards (8 Oct: "in the service queue rows and on the workbench cards
// it should list total time"). One request for the whole list, refreshed every
// minute so a running timer's total keeps up. No Lightspeed calls behind it.
import React, { useEffect, useState } from 'react';
import { API, authHeaders } from '../utils/helpers';

const REFRESH_MS = 60 * 1000;

export function useTimeTotals(ids) {
  const key = [...new Set((ids || []).map(String))].sort().join(',');
  const [totals, setTotals] = useState({});
  useEffect(() => {
    if (!key) { setTotals({}); return undefined; }
    let cancelled = false;
    const load = () => fetch(`${API}/api/timer/totals?ids=${encodeURIComponent(key)}`, { credentials: 'include', headers: authHeaders() })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (!cancelled && d && d.totals) setTotals(d.totals); })
      .catch(() => {});
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, [key]);
  return totals;
}

export function fmtTotal(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  let mins = Math.round(s / 60);
  if (s > 0 && mins === 0) mins = 1;
  return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, '0')}m`;
}

// "⏱ 1h 25m", green with a dot while someone's timer is running. Nothing at all
// for a ticket with no time, so untouched tickets stay clean.
export function TimeBadge({ total, isDark, style }) {
  if (!total || !(total.seconds > 0 || total.running)) return null;
  const live = !!total.running;
  const techs = total.techs > 1 ? ` · ${total.techs} techs` : '';
  return (
    <span title={`${fmtTotal(total.seconds)} of tech time on this ticket${techs}${live ? ' · timer running' : ''}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, padding: '2px 8px', borderRadius: 999,
        whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', fontWeight: 600,
        color: live ? '#1e9e57' : (isDark ? '#b9c6dd' : '#3b4a63'),
        background: live ? (isDark ? '#0f2a15' : '#d4edda') : (isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.05)'),
        ...style }}>
      {live
        ? <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#2ecc71' }} />
        : <span aria-hidden="true">⏱</span>}
      {fmtTotal(total.seconds)}
    </span>
  );
}
